export function insertInfoTextAfterCompleation(item, text, position) {
  let infoTextAfter = `<p ${position === "afterend" ? `class="mt-4 w-full"` : ``}>${text}</p>`;
  item.insertAdjacentHTML(position, infoTextAfter);

  return insertInfoTextAfterCompleation;
}
